export const SEND_SMS_OPEN = 'SEND_SMS_OPEN'
export const SEND_SMS_CLOSE = 'SEND_SMS_CLOSE'

export const SEND_SMS_SET_STATE = 'SEND_SMS_SET_STATE'

export const SEND_SMS_TOGGLE_COLLAPSE = 'SEND_SMS_TOGGLE_COLLAPSE'

export const SEND_SMS_CREATE_DRAFT_REQUESTED = 'SEND_SMS_CREATE_DRAFT_REQUESTED'
export const SEND_SMS_CREATE_DRAFT_SUCCESS = 'SEND_SMS_CREATE_DRAFT_SUCCESS'
export const SEND_SMS_CREATE_DRAFT_ERROR = 'SEND_SMS_CREATE_DRAFT_ERROR'

export const SEND_SMS_IS_COLLAPSED = 'SEND_SMS_IS_COLLAPSED'

export const SEND_SMS_UPDATE_DRAFT_REQUESTED = 'SEND_SMS_UPDATE_DRAFT_REQUESTED'
export const SEND_SMS_UPDATE_DRAFT_SUCCESS = 'SEND_SMS_UPDATE_DRAFT_SUCCESS'
export const SEND_SMS_UPDATE_DRAFT_ERROR = 'SEND_SMS_UPDATE_DRAFT_ERROR'

export const SEND_SMS_DELETE_DRAFT_REQUESTED = 'SEND_SMS_DELETE_DRAFT_REQUESTED'
export const SEND_SMS_DELETE_DRAFT_SUCCESS = 'SEND_SMS_DELETE_DRAFT_SUCCESS'
export const SEND_SMS_DELETE_DRAFT_ERROR = 'SEND_SMS_DELETE_DRAFT_ERROR'

export const SEND_SMS_FETCH_SETTINGS_REQUESTED =
  'SEND_SMS_FETCH_SETTINGS_REQUESTED'
export const SEND_SMS_FETCH_SETTINGS_SUCCESS = 'SEND_SMS_FETCH_SETTINGS_SUCCESS'
export const SEND_SMS_FETCH_SETTINGS_ERROR = 'SEND_SMS_FETCH_SETTINGS_ERROR'

export const SEND_SMS_REQUESTED = 'SEND_SMS_REQUESTED'
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS'
export const SEND_SMS_ERROR = 'SEND_SMS_ERROR'

export const SEND_SMS_FETCH_RECIEPT_REQUESTED =
  'SEND_SMS_FETCH_RECIEPT_REQUESTED'
export const SEND_SMS_FETCH_RECIEPT_SUCCESS = 'SEND_SMS_FETCH_RECIEPT_SUCCESS'
export const SEND_SMS_FETCH_RECIEPT_ERROR = 'SEND_SMS_FETCH_RECIEPT_ERROR'

export const SEND_SMS_UPDATE_RECIPIENTS_REQUESTED =
  'SEND_SMS_UPDATE_RECIPIENTS_REQUESTED'
export const SEND_SMS_UPDATE_RECIPIENTS_SUCCESS =
  'SEND_SMS_UPDATE_RECIPIENTS_SUCCESS'
export const SEND_SMS_UPDATE_RECIPIENTS_ERROR =
  'SEND_SMS_UPDATE_RECIPIENTS_ERROR'

export const SEND_SMS_UPDATE_MANY_RECIPIENTS_REQUESTED =
  'SEND_SMS_UPDATE_MANY_RECIPIENTS_REQUESTED'
export const SEND_SMS_UPDATE_MANY_RECIPIENTS_SUCCESS =
  'SEND_SMS_UPDATE_MANY_RECIPIENTS_SUCCESS'
export const SEND_SMS_UPDATE_MANY_RECIPIENTS_ERROR =
  'SEND_SMS_UPDATE_MANY_RECIPIENTS_ERROR'

export const SEND_SMS_REMOVE_RECIPIENT_REQUESTED =
  'SEND_SMS_REMOVE_RECIPIENT_REQUESTED'
export const SEND_SMS_REMOVE_RECIPIENT_SUCCESS =
  'SEND_SMS_REMOVE_RECIPIENT_SUCCESS'

export const SEND_SMS_SET_CREATE_CONTACT = 'SEND_SMS_SET_CREATE_CONTACT'
export const SEND_SMS_CREATE_CONTACT_REQUESTED =
  'SEND_SMS_CREATE_CONTACT_REQUESTED'
export const SEND_SMS_CREATE_CONTACT_SUCCESS = 'SEND_SMS_CREATE_CONTACT_SUCCESS'
export const SEND_SMS_CREATE_CONTACT_FAILED = 'SEND_SMS_CREATE_CONTACT_FAILED'

export const SEND_SMS_RESET = 'SEND_SMS_RESET'

export const SEND_SMS_UPDATE_SENDING_STATUS_REQUESTED =
  'SEND_SMS_UPDATE_SENDING_STATUS_REQUESTED'
export const SEND_SMS_UPDATE_SENDING_STATUS_SUCCESS =
  'SEND_SMS_UPDATE_SENDING_STATUS_SUCCESS'
export const SEND_SMS_UPDATE_SENDING_STATUS_ERROR =
  'SEND_SMS_UPDATE_SENDING_STATUS_ERROR'

export const SEND_SMS_REFETCH_SENDING_STATUS_REQUESTED =
  'SEND_SMS_REFETCH_SENDING_STATUS_REQUESTED'
export const SEND_SMS_REFETCH_SENDING_STATUS_SUCCESS =
  'SEND_SMS_REFETCH_SENDING_STATUS_SUCCESS'

export const SEND_SMS_RECIPIENTS_TO_LOADING_LIST_REQUESTED =
  'SEND_SMS_RECIPIENTS_TO_LOADING_LIST_REQUESTED'
export const SEND_SMS_RECIPIENTS_TO_LOADING_LIST_SUCCESS =
  'SEND_SMS_RECIPIENTS_TO_LOADING_LIST_SUCCESS'
